import { ProductCode, AccessLevel } from '@dev/ee-api/ee-api-models';
import { useAccessLevel } from '../useAccessLevel';
import { useCurrentPlanStatus } from '../useCurrentPlanStatus';
import { useConfigProductCode } from '../useConfigProductCode';

type DashboardElementVisibliity = {
    isCreatorOnboardingSurveyVisible: boolean;

    menuProductCode: ProductCode;
    isCreatorMenuVisible: boolean;

    editors: {
        isHtmlEditorVisible: boolean;
        isFormClassicDesignerVisible: boolean;
    };

    upselling: {
        isSendTimeOptimizationUpsellingVisible: boolean;
        isAutomationUpsellingVisible: boolean;
    };

    activity: {
        isActivityVisible: boolean;
    };

    settings: {
        isSettingsAccessTokensVisible: boolean;
        isSettingsPanelVisible: boolean;
    };

    automations: {
        isAutomationTriggerContactAddedByApiVisible: boolean;
    };

    audience: {
        isAudienceTransactionalContactStatusVisible: boolean;
    };

    linkInBio: {
        isLinkInBioInsteadLandingPageVisible: boolean;
    };
};

export const useDashboardElementVisibility = (): DashboardElementVisibliity => {
    const { hasAccessLevel } = useAccessLevel();
    const { isTrialOrFree, isPilotPlan } = useCurrentPlanStatus();
    const productCode = useConfigProductCode();
    const isNotPaying = isTrialOrFree || isPilotPlan;

    const isCreatorProduct = productCode === ProductCode.CreatorSuite;

    return {
        isCreatorOnboardingSurveyVisible: isCreatorProduct,
        menuProductCode: isCreatorProduct ? ProductCode.CreatorSuite : ProductCode.Marketing,
        isCreatorMenuVisible: isCreatorProduct,

        editors: {
            isHtmlEditorVisible: !isCreatorProduct && hasAccessLevel(AccessLevel.ViewHTMLEditor),
            isFormClassicDesignerVisible: !isCreatorProduct,
        },

        upselling: {
            isSendTimeOptimizationUpsellingVisible: isCreatorProduct && isNotPaying,
            isAutomationUpsellingVisible: isCreatorProduct && isNotPaying,
        },
        activity: {
            isActivityVisible: !isCreatorProduct,
        },
        settings: {
            isSettingsAccessTokensVisible: !isCreatorProduct && hasAccessLevel(AccessLevel.ViewAccessTokens),
            isSettingsPanelVisible: !isCreatorProduct,
        },
        automations: {
            isAutomationTriggerContactAddedByApiVisible: !isCreatorProduct,
        },
        audience: {
            isAudienceTransactionalContactStatusVisible: !isCreatorProduct,
        },

        linkInBio: {
            isLinkInBioInsteadLandingPageVisible: isCreatorProduct,
        },
    };
};
